import { AppBar, MenuItem, Select, Toolbar } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import './index.css';

const MasterBar = props => {
	if (!props.canDisplay) return '';

	return (
		<AppBar position="static" id="masterBar">
			<Toolbar variant="dense">
				{I18n.t('master.connectedAs')} :{' '}
				<Select
					value={props.connectedAs ? props.connectedAs.account_id : 0}
					onChange={e => {
						props.selectChild(e.target.value);
					}}>
					<MenuItem key={99} value={0}>
						{props.username} ({I18n.t('master.masterAccount')})
					</MenuItem>
					{props.children.map((item, index) => (
						<MenuItem key={index} value={item.id_child}>
							{item.company}
						</MenuItem>
					))}
				</Select>
			</Toolbar>
		</AppBar>
	);
};

const mstp = state => {
	const isMaster = state.service.user.children.length;
	return {
		canDisplay: isMaster,
		username: state.service.user.username,
		children: state.service.user.children,
		connectedAs: state.service.user.connectedAs,
	};
};

const mdtp = dispatch => {
	return {
		selectChild: id => dispatch({ type: 'SELECT_CHILD', id }),
	};
};

export default connect(mstp, mdtp)(MasterBar);
